












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { db, firebase } from '../lib/firebase'
import User from '../model/user'
import Project from '../model/project'
import JoinButton from '@/components/JoinButton.vue'

@Component({
  components: {
  JoinButton,
  }
  })
export default class ProjectDetail extends Vue {
  user: User | null = null
  project: Project | null = null
  db = firebase.firestore()

  /* eslint-disable */
  protected project_title = '';
  protected owner_name = '';
  protected photo_url = '';
  protected overview = '';
  protected need_skills = '';
  /* eslint-enable */

  created () {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        this.user = await User.findByUid(user.uid)
        db.collection('users').doc(this.user.uid).onSnapshot((doc) => {
          const data= doc.data()
          if (data) {
            this.user = new User(data)
          }
        });
      } else {
        this.user = null
      }
    })

    const project_id = this.$route.query.project_id
    db.collection('projects').doc(project_id).onSnapshot((doc) => {
      const data = doc.data()
      if (data) {
        this.project = new Project(data)
        this.project_title = data.title || ''
        this.owner_name = (data.owner && data.owner.name) || ''
        this.overview = data.overview || ''
        this.need_skills = data.need_skills || ''
      }
    });
  }

  joinEnable (): boolean {
    const user = this.user
    if (!user) { return false }
    if (!this.project || !this.project.members) { return true }

    const exist = this.project.members.find((m) => m.uid === user.uid)
    return !exist
  }

  join () {
    if (!this.user) { return }
    if (!this.project || !this.project.uid) { return }

    this.user.joinProject(this.project.uid)
  }

  needLogin () {
    return !this.user
  }
}
